export default "__VITE_ASSET__6bd36372__"